module.exports = __webpack_public_path__ + "static/media/17.a4d598c3.jpg";